import { useCallback, useEffect, useState } from 'react';
import { listPending, subscribePending } from '../services/offlineQueue';

/** Expenses waiting in the offline queue, kept up to date. */
function usePendingExpenses() {
  const [pending, setPending] = useState([]);

  const refresh = useCallback(() => {
    listPending().then(setPending);
  }, []);

  useEffect(() => {
    refresh();
    return subscribePending(refresh);
  }, [refresh]);

  return pending;
}

export default usePendingExpenses;
